module.exports = __webpack_public_path__ + "zilky-v-obliceji_2_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/zilky-v-obliceji_2_before.jpg
// module id = 996
// module chunks = 0